@if (showSchedule) {
<div style="height: 100%!important;flex-direction:row;box-sizing:border-box;display:flex;width:100%">
  @switch (projectTab().ProjectTypeId) {
  @case (57) {
  <app-schedule-task-surfacedev
    [projectTab]="projectTab()"
    style="height:100%;width:100%;flex-direction:column;display:flex; flex: 1 1 100%; max-width:100%">
  </app-schedule-task-surfacedev>
  }
  @default {
  <app-schedule-task
    [projectTab]="projectTab()"
    style="height:100%;width:100%;flex-direction:column;display:flex; flex: 1 1 100%; max-width:100%">
  </app-schedule-task>
  }
  }
</div>
} @else {
@if (projectTab().ProjectTypeId==57) {
<div style="height:100%;width:100%; align-items:center;display:flex;flex-flow:column;justify-content: center;">
  <h1>Pad Construction Schedules Coming Soon</h1>
  <kendo-loader
    [type]="loader.type"
    [themeColor]="loader.themeColor"
    [size]="loader.size">
  </kendo-loader>
</div>
}
}